import React, { Component } from "react";
import { BallTriangle } from "react-loader-spinner";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import agent from "../../agent";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { PayloadSubjectUtils } from "./IPayloadProps";
import DeepLink from "./../DeepLink";

const short = require("short-uuid");

export interface PaymentQRState {
  uri?: string;
  preAuthCode?: string;
  qrCode?: JSX.Element;
  qrData?: any;
  credentialPaymentIssued?: boolean;
}

export interface IInsuranceInfoProps {
  payload: AuthorizationResponsePayload;
  signalIfValid: (isValid: boolean) => void;
  amount?: string;
  duration?: string;
  insuranceName: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default class InsuranceReadyStep extends Component<
  IInsuranceInfoProps,
  PaymentQRState
> {
  subjects = new PayloadSubjectUtils();
  paymentTitle = "Please scan the QR code with your app.";
  paymentSubtitle = "Please process the following invoice.";
  insuranceTitle = "Thank your for your payment!";
  renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  componentDidMount() {
    // this.generateNewQRCodeForInsurance();
  }

  componentWillUnmount() {
    this.setState({});
  }

  render() {
    console.log(`====> render qr ${this.state?.qrCode}`);
    return true ? (
      <div style={{ minHeight: "430px", textAlign: "center" }}>
        <h3>
          Your insurance policy is ready! 
        </h3>
        <div className="qr-code-ssi">{this.state?.qrCode}</div>
      </div>
    ) : this.state?.credentialPaymentIssued === true ? (
      <div style={{ height: "150px" }}>
        <h3>Thank you for your trust!</h3>
      </div>
    ) : (
      <BallTriangle color="#352575" height="100" width="100" />
    );
  }

  // private async generateNewQRCodeForInsurance() {
  //   const shortUuid = short.generate();
  //   let customerNumber = "34223324";
  //   let policyNumber = "32434545";
  //   let customerName = this.subjects.getSubjects(this.props.payload)?.firstName + " " + this.subjects.getSubjects(this.props.payload)?.lastName;
  //   let customerAddress = this.subjects.getSubjects(
  //     this.props.payload,
  //   )?.addresses;
  //   let dateOfBirth = this.subjects.getSubjects(
  //     this.props.payload,
  //   )?.dateOfBirth;
  //   let emails = this.subjects.getSubjects(this.props.payload)?.emails;
  //   let insuranceType = this.props.insuranceName;
  //   let insuredAmount = this.props.amount;
  //   let insuranceDuration = this.props.duration;
  //   let insuranceCompany = "Demo Insurance";
  //   const uriData: IOID4VCIClientCreateOfferUriResponse =
  //     await agent.oid4vciClientCreateOfferUri({
  //       grants: {
  //         "urn:ietf:params:oauth:grant-type:pre-authorized_code": {
  //           "pre-authorized_code": shortUuid,
  //           user_pin_required: false,
  //         },
  //       },
  //       credentialDataSupplierInput: {
  //         policyNumber: policyNumber,
  //         customerNumber: customerNumber,
  //         customerName: customerName,
  //         customerAddress: customerAddress,
  //         dateOfBirth: dateOfBirth,
  //         email: emails,
  //         insuranceType: insuranceType,
  //         insuredAmount: insuredAmount,
  //         insuranceDuration: insuranceDuration,
  //         insuranceCompany: insuranceCompany,
  //       },
  //       credentials: ["netceteraInsurance"],
  //     });

  //   const qrState = {
  //     uri: uriData.uri,
  //     preAuthCode: shortUuid,
  //     qrData: {
  //       object: uriData.uri,
  //       type: QRType.URI,
  //       id: "567",
  //     },
  //   };
  //   this.setState(qrState);

  //   agent
  //     .qrURIElement({
  //       data: this.state.qrData,
  //       renderingProps: this.renderingProps,
  //     })
  //     .then((qrCode: JSX.Element) => {
  //       this.setState({ ...this.state, qrCode: qrCode });
  //     });

  //   const intervalId = setInterval(() => {
  //     agent
  //       .oid4vciClientGetIssueStatus({ id: this.state?.preAuthCode! })
  //       .then((status: IssueStatusResponse) => {
  //         if (status.status === IssueStatus.CREDENTIAL_ISSUED) {
  //           clearInterval(intervalId);
  //           this.setState({
  //             ...this.state,
  //             qrCode: undefined,
  //             credentialPaymentIssued: true,
  //           });
  //         } else if (status.status === IssueStatus.ERROR) {
  //           // TODO: Add feedback to user
  //           console.error(status.error);
  //           clearInterval(intervalId);
  //         }
  //       })
  //       .catch((error: Error) => {
  //         clearInterval(intervalId);
  //         console.error(`ERROR: ${error.message}`);
  //       });
  //   }, 1000);
  // }
}
